import { render, staticRenderFns } from "./ContestEntryItem.vue?vue&type=template&id=0c9c3a00&scoped=true"
import script from "./ContestEntryItem.vue?vue&type=script&lang=ts"
export * from "./ContestEntryItem.vue?vue&type=script&lang=ts"
import style0 from "./ContestEntryItem.vue?vue&type=style&index=0&id=0c9c3a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9c3a00",
  null
  
)

export default component.exports